import { environment } from '@shared/environments/environment';
import { AuthConfig } from '@auth0/auth0-angular';

export default {
  domain: environment.auth0.domain,
  clientId: environment.auth0.clientId,
  useRefreshTokens: true,
  cacheLocation: 'localstorage',
  authorizationParams: {
    audience: `https://${environment.auth0.audience}/api/v2/`,
    redirect_uri: window.location.origin,
  },
  httpInterceptor: {
    allowedList: [
      `${environment.api.host}/auth/userinfo`,
      `${environment.api.host}/v1/*`,
      `${environment.api.host}/v2/*`,
    ]
  },
} as AuthConfig
